export default __webpack_public_path__ + "static/media/health_check_female_Hk.11c270bc.webp";